import React, {useState} from "react";
import {
    ReviewPageLeftSection,
    ReviewDischargePatientButton,
    Heading,
    DemographicsContainer,
    Span,
} from "./ReviewClassRightSection.styles";
import {
    DetailContainer,
    DetailCard,
    DetailCardWrapper,
} from "../../ReviewClassDetail.styles";
import { ReviewClassDetailPageTable } from "../ReviewClassDetailPageTable/ReviewClassDetailPageTable";
import { LocationIcon } from "../../../../../components/core/location-icon/LocationIcon";
import GenderIcon from "../../../../../components/core/gender-icon/GenderIcon";
import DischargePatientModal from "../../../../../components/core/modal/discharge-patient/DischargePatient";

// Interface for the discharge patient details
export interface DischargedPatient {
    id: string;
    location: any;
    name: string;
    demographics: string;
    symptom: string;
    diagnosis: string;
    real_diagnosis?: string;
    score?: number;
    actions?: any;
    feedback?: string;
}
export interface ReviewClassLeftSectionProps {
    selectedRow: any;
    tableData: Array<any>;
    translations: any;
}
const ReviewClassRightSection: React.FC<ReviewClassLeftSectionProps> = ({
    tableData,
    selectedRow,
    translations,
}) => {
    console.log("Right Section Translations", translations);
    const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
    
        // State to store the selected discharged patient data
        const [selectedPatientData, setSelectedPatientData] = useState<DischargedPatient | null>(null);
    
        const showFeedbackPopup = (patient_id: number): void => {
            // Find the discharged patient from the data array
            const dischargedPatient = tableData.find(patient => Number(patient.id) === patient_id);
    
            if (dischargedPatient) {
    
                setSelectedPatientData(dischargedPatient);
                setFeedbackModalOpen(true);
            }
        };
    const diseaseTableColumns = [
        {
            key: "name",
            label: translations.table.columns.name,
            render: (patient: DischargedPatient) => <span>{patient.name}</span>,
        },
        {
            key: "demographics",
            label: translations.table.columns.ageGender,
            render: (patient: DischargedPatient) => {
                const [age, gender] = patient.demographics?.split(" ");
                return (
                    <DemographicsContainer>
                        {age}{" "}
                        <GenderIcon
                            gender={gender === "Male" ? "male" : "female"}
                        />
                    </DemographicsContainer>
                );
            },
        },
        {
            key: "symptom",
            label: translations.table.columns.symptom,
            render: (patient: DischargedPatient) => (
                <span>
                    {translations.symptoms[patient.symptom]} 
                </span>
            ),
        },
        {
            key: "diagnosis",
            label: translations.table.columns.diagnosis,
            render: (patient: DischargedPatient) => (
                <span>
                    {patient.diagnosis ? translations.diagnosis[patient.diagnosis] : null}
                </span>
            ),
        },
        {
            key: "real_diagnosis",
            label: translations.table.columns.realDiagnosis,
            render: (patient: DischargedPatient) => (
                <span>
                    {patient.real_diagnosis ? translations.diagnosis[patient.real_diagnosis] : null}
                </span>
            ),
        },
        {
            key: "score",
            label: translations.table.columns.score,
            render: (patient: DischargedPatient) => (
                <span>{patient.score ?? "N/A"}</span>
            ),
        },
        {
            key: "review",
            label: translations.table.columns.review,
            render: (patient: DischargedPatient) => (
                <ReviewDischargePatientButton
                    onClick={() => showFeedbackPopup(Number(patient.id))}
                >
                    {translations.table.feedback}
                </ReviewDischargePatientButton>
            ),
        },
    ];
    return (
        <ReviewPageLeftSection>
            <DetailContainer>
                <DetailCardWrapper>
                    <DetailCard>
                        <Heading>Patients Information</Heading>
                        <ReviewClassDetailPageTable
                            data={tableData}
                            columns={diseaseTableColumns}
                        />
                    </DetailCard>
                </DetailCardWrapper>
            </DetailContainer>
            {feedbackModalOpen && selectedPatientData && (
                <DischargePatientModal
                    patient={selectedPatientData}
                    translations={translations}
                    onClose={() => {
                        setFeedbackModalOpen(false);
                        setSelectedPatientData(null); // Clear selected patient data when closing
                    }}
                />
            )}
        </ReviewPageLeftSection>
    );
};

export default ReviewClassRightSection;
